import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LockIcon, TrophyIcon } from 'lucide-react';
import { useSession } from '../contexts/SessionContext';
import { CHAMPION_SHIRT_PATH } from '../data/site';
type ChampionShirtAccessProps = {
  variant: 'loginRequired' | 'unavailable';
};
const loginPath = `/login?redirect=${encodeURIComponent(CHAMPION_SHIRT_PATH)}`;
export function ChampionShirtAccess({
  variant
}: ChampionShirtAccessProps) {
  const {
    firstName,
    logout
  } = useSession();
  const navigate = useNavigate();
  const unavailable = variant === 'unavailable';
  const switchAccount = () => {
    logout();
    navigate(loginPath);
  };
  return <section aria-labelledby="shirt-access-title" className="w-full max-w-xl" data-id="element-36" data-mp="2amb95kmfohxx">
      <div className="rounded-lg border border-gray-200 bg-[#F7F8FB] p-7" data-id="element-37" data-mp="2ak8l364ucyvu">
        <div className="flex items-center gap-3" data-id="element-38" data-mp="1wn21j9camw5k">
          <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full ${unavailable ? 'bg-navy/10 text-navy' : 'bg-gold/25 text-gold-dark'}`} aria-hidden data-id="element-39" data-mp="21ldc5maexaou">
            {unavailable ? <LockIcon className="h-5 w-5" data-id="element-40" data-mp="a5web1g8y407" /> : <TrophyIcon className="h-5 w-5" data-id="element-41" data-mp="o5xfyj4c5fgq" />}
          </span>
          <h2 id="shirt-access-title" className="font-condensed text-2xl font-semibold uppercase leading-tight md:text-[28px]" data-id="element-42" data-mp="o55sjvkw6o1j">
            {unavailable ? 'Not available on this account' : 'Log in to purchase'}
          </h2>
        </div>

        <p className="mt-4 text-[16px] leading-relaxed text-navy/80" data-id="element-43" data-mp="3mnumi9hgu219">
          The League Champion shirt is available exclusively to families of Championship-winning players for 30 days after the game.
          If your player was on the winning team, log in to the member account used for registration to purchase.
        </p>

        {unavailable && <p className="mt-4 border-t border-gray-200 pt-4 text-sm text-navy/60" data-id="element-44" data-mp="38uboopo4fhf5">
            You’re signed in as <span className="font-semibold text-navy" data-id="element-45" data-mp="33wtdstqjms4i">{firstName}</span>.
          </p>}

        <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-46" data-mp="17ton5gb9cfvj">
          {unavailable ? <>
              <button onClick={switchAccount} className="rounded bg-brand-red px-5 py-3 font-bold uppercase tracking-wide text-white transition-colors duration-150 hover:bg-brand-red-dark" data-id="element-47" data-mp="1hjqau6zp7w9x">
                Log in with another account
              </button>
              <Link to="/" className="px-2 py-3 text-center font-semibold text-[#1F3BB3] hover:underline" data-id="element-48" data-mp="tu5snqbdd31p">
                Back to Store Home
              </Link>
            </> : <>
              <Link to={loginPath} className="rounded bg-brand-red px-8 py-3 text-center font-bold uppercase tracking-wide text-white transition-colors duration-150 hover:bg-brand-red-dark" data-id="element-49" data-mp="12ulu6u8jy03x">
                Log in
              </Link>
              <span className="text-sm text-navy/70" data-id="element-50" data-mp="2odxvbsf6ogx9">
                New to i9 Sports?{' '}
                <Link to={loginPath} className="font-semibold text-brand-red hover:underline" data-id="element-51" data-mp="2ofs468d6kikz">Create an account</Link>
              </span>
            </>}
        </div>
      </div>
    </section>;
}